"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isThresholdSettingsMalformed = void 0;
const isUsable = (settings) => {
    if (typeof settings !== 'object' || settings === null) {
        return false;
    }
    const { impacts, onlyNewIssues } = settings;
    return (typeof impacts?.value === 'object' &&
        impacts.value !== null &&
        !Array.isArray(impacts.value) &&
        typeof onlyNewIssues?.value === 'boolean');
};
/**
 * Whether a stored settings value is there but cannot be read as this schema.
 *
 * The threshold reports such a value as absent settings rather than throwing, which makes it
 * indistinguishable from a session that has none. This tells the two apart.
 *
 * @param settings - A `jsonb` value of any shape
 * @returns `false` when nothing is stored, `true` when what is stored is unusable
 */
const isThresholdSettingsMalformed = (settings) => settings !== null && settings !== undefined && !isUsable(settings);
exports.isThresholdSettingsMalformed = isThresholdSettingsMalformed;
/**
 * Calculate number of issues over a11y threshold
 *
 * @param settings - AxeDeveloperHub settings object
 * @param overview - Narrowed to the counts the threshold reads, so a caller that has
 * only those need not invent the rest of a `DedupedOverview`.
 * @returns - Number of issues over a11y threshold
 */
const a11yThresholdResults = (settings, overview) => {
    if (!settings || !isUsable(settings)) {
        return null;
    }
    const { impacts, onlyNewIssues } = settings;
    let issuesOverA11yThreshold = 0;
    for (const impact of Object.keys(impacts.value)) {
        const counts = overview.numIssueSeverity[impact];
        /* Skip impact if it's not enabled within settings, or carries no counts */
        if (!impacts.value[impact] || !counts) {
            continue;
        }
        if (onlyNewIssues.value) {
            issuesOverA11yThreshold += counts.numNew;
        }
        else {
            issuesOverA11yThreshold += counts.totalCurrent;
        }
    }
    return issuesOverA11yThreshold;
};
exports.default = a11yThresholdResults;
//# sourceMappingURL=a11yThresholdResults.js.map